import React from 'react';
import { Box, Text } from '@wix/design-system';
import { InfoLine } from '../InfoSection';
import s from './InvoiceHighlight.scss';
export const InvoiceHighlight = ({ amountPaid, children, dueAmount, dueDate, t, }) => {
    return (React.createElement(Box, { marginTop: "20px", align: "center", direction: "vertical" },
        React.createElement(Box, null,
            React.createElement(Text, { className: s.dueAmount }, dueAmount)),
        !amountPaid ? (React.createElement(Box, { marginTop: "12px" },
            React.createElement(Text, null, t('price-quote.view.highlight-section.point-to-due-date', {
                date: dueDate,
            })))) : (React.createElement(React.Fragment, null,
            React.createElement(InfoLine, { marginTop: "12px" }, t('price-quote.view.highlight-section.point-to-due-date', {
                date: dueDate,
            })),
            !!amountPaid && (React.createElement(InfoLine, { weight: "bold" }, t('price-quote.view.highlight-section.amount-paid', {
                money: amountPaid,
            }))))),
        !!children && React.createElement(Box, { marginTop: "16px" }, children)));
};
//# sourceMappingURL=InvoiceHighlight.js.map